import {
  SubscriptionStatus,
  WorkspacePlan,
} from '@up2stay/up2promo-api-client';

export type SidebarUpgradeTeaserInput = {
  canManageBilling: boolean;
  isLoading: boolean;
  plan: WorkspacePlan | undefined;
  status: SubscriptionStatus | undefined;
  hasActiveBillingGrant: boolean;
};

/**
 * Plan upgrade teaser (sidebar footer + More hub): free / trial / unpaid
 * workspaces where the viewer can manage billing. Hidden for paid active
 * (non-trial) plans and billing grants. Copy variant →
 * `resolveSidebarUpgradeTeaserVariant`.
 */
export function shouldShowSidebarUpgradeTeaser(
  input: SidebarUpgradeTeaserInput,
): boolean {
  if (input.isLoading || !input.canManageBilling || !input.plan) {
    return false;
  }

  if (input.hasActiveBillingGrant) {
    return false;
  }

  if (input.plan === WorkspacePlan.FREE) {
    return true;
  }

  if (
    input.status === SubscriptionStatus.TRIALING ||
    input.status === SubscriptionStatus.UNPAID ||
    input.status === SubscriptionStatus.PAST_DUE ||
    input.status === SubscriptionStatus.CANCELED ||
    input.status === SubscriptionStatus.INCOMPLETE ||
    input.status === SubscriptionStatus.INCOMPLETE_EXPIRED ||
    input.status === SubscriptionStatus.PAUSED
  ) {
    return true;
  }

  // Paid Plus / Teams / Enterprise with an active subscription.
  return false;
}
